<script lang="ts" setup>
import { ColumnData, ButtonAlign } from '~~/server/api/pagebuilder'

export type PagebuilderButtonAlignKeys = 'left' | 'center' | 'right'

export interface PagebuilderButtonAlignOptions {
    [key: string]: PagebuilderButtonAlignKeys
}

export interface PagebuilderButtonProps {
    data: ColumnData
}
export type PagebuilderButtonAlign<T> = {
    [Property in keyof T as ButtonAlign]: T[Property]
}

const props = defineProps<PagebuilderButtonProps>()

</script>
<template>
  <VButton
    :to="props.data.url"
    :color="props.data.type"
    class="me-4 mb-4"
    :target="props.data.target_blank === '1' ? '_blank' : '_self'"
  >
    {{ props.data.name }}
  </VButton>
</template>
